export const validatePhoneNumber = (number: string) => {
  // Simple regex for a 10-digit phone number (can be adjusted based on format)
  const regex = /^[0-9]{10}$/;
  return regex.test(number);
};

export const validateEmail = (email: string) => {
  // Simple regex for a 10-digit phone number (can be adjusted based on format)
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateURL = (url: string) => {
  const regex = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/;
  return regex.test(url);
};

export const validateName = (name: string) => {
  const regex = /^[A-Za-z\s]+$/;
  return regex.test(name);
};
